// Keep product identity resolution independent of Axios and Redux. The shared
// product config loads this module lazily, so app-core APIs can resolve their
// default scope without importing the entire API/state graph during startup.
const HOSTNAME_APP_ID_MAP = {
  'juristai.org': '2',
  'www.juristai.org': '2',
  'fedcrim.ai': '1',
  'www.fedcrim.ai': '1',
  'atticusai.org': '1',
  'www.atticusai.org': '1',
  'litigai.org': '2',
  'www.litigai.org': '2',
  'seriesai.co': '3',
  'www.seriesai.co': '3',
};

const getWindowLocation = () =>
  typeof window !== 'undefined' && window.location ? window.location : undefined;

const resolvePathAppId = (pathname = '') =>
  pathname.match(/^\/dashboard\/(1|2|3|4)(?:\/|$)/)?.[1];

const resolveRedirectAppId = (location) => {
  if (!location?.search) return undefined;

  const params = new URLSearchParams(location.search);
  const redirectValue = params.get('redirect_url') || params.get('redirectUrl') || params.get('redirect');
  if (!redirectValue) return undefined;

  try {
    const redirectUrl = redirectValue.startsWith('/')
      ? new URL(redirectValue, 'https://juristai.org')
      : new URL(redirectValue);
    return resolvePathAppId(redirectUrl.pathname);
  } catch (_error) {
    return undefined;
  }
};

const resolveHostnameAppId = () => {
  const location = getWindowLocation();
  const hostname = location?.hostname?.toLowerCase();
  if (!hostname) return undefined;

  return resolvePathAppId(location.pathname)
    || resolveRedirectAppId(location)
    || HOSTNAME_APP_ID_MAP[hostname];
};

export const APP_ID = process.env.REACT_APP_APP_ID || resolveHostnameAppId() || '1';

// The unified host can switch practice areas without a full page reload.
export const getCurrentAppId = () => {
  const location = getWindowLocation();
  const routeAppId = resolvePathAppId(location?.pathname);
  const redirectAppId = resolveRedirectAppId(location);
  return routeAppId || redirectAppId || process.env.REACT_APP_APP_ID || resolveHostnameAppId() || APP_ID;
};
